
 

const mutations = {
  SET_ALL_STRATEGIES(state, payload) {
    if (payload && payload.length) {
      state.allStrategies = formatStategiesData(payload);
      state.dates = payload[0].Row[0];
      state.resultCount = payload[0].Row[0].VehicleCount;
    }
  },
  SET_RETURNS_PERIOD(state, selectedReturnPeriod) {
    state.returnsPeriod = selectedReturnPeriod;
  }
};

const actions = {
  setReturnsPeriod({ commit }, returnPeriodPrefix) {
    if (returnPeriodPrefix) {
      commit('SET_RETURNS_PERIOD', returnPeriodPrefix);
    }
  }
};

const getters = {
  allStrategies: state => state.allStrategies,
  resultCount: state => state.resultCount,
  returnsPeriod: state => state.returnsPeriod,
  dates: state => state.dates
};

const state = {};
state.allStrategies = [];
state.resultCount = 0;
state.returnsPeriod = 'Monthly';
state.dates = {};

function formatStategiesData(data) {
  let formattedStrategiesData = [];
  // remove the first element that only contains the dates.
  data = data.slice(1);
  // isolate the relevent Strategies data, organized by objective type.
  formattedStrategiesData = data.map(objective => {
    return {
      objectiveLable: objective.Row[0].Objective,
      strategies: addHeaderRow(objective.Row)
    };
  });
  return formattedStrategiesData;
}

function addHeaderRow(strategies) {
  const result = strategies;

  let previousStrategy;
  let currentStrategy;

  strategies.forEach((strategy, index) => {
    currentStrategy = strategy.Name;

    if (currentStrategy !== previousStrategy && strategy.VehicleType !== 'Benchmark') {
      previousStrategy = currentStrategy;
      result.splice(index, 0, {
        headerRow: true,
        name: strategy.Name,
        URLString: strategy.URLString,
        tradeMarkType: strategy.TradeMarkType
      });
    }
  });

  return result;
}

export default {
  state,
  getters,
  mutations,
  actions
};

